<!DOCTYPE html>
<html lang="zh" data-html-attrs-placeholder>
  <head>
    <meta charset="UTF-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1">
    <meta name="renderer" content="webkit">
    <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1, shrink-to-fit=no, viewport-fit=cover">
    <meta name="format-detection" content="telephone=no,email=no">
    <link rel="icon" href="%VITE_FAVICON_URL%">
    <!--app-head-->
  </head>
  <body data-body-attrs-placeholder>
    <!--body-tags-open-->
    <!--boot-progress-->
    <div id="app"><!--app-html--></div>
    <!--app-state-->
    <!--body-tags-->
    <script type="module" src="/src/entry-client.ts"></script>
  </body>
</html>
